// export const turnstileSiteKey = TURNSTILE_SITE_KEY;

$(document).on("turbo:frame-load turbo:frame-render", function () {
    turnstile.ready(function () {
        // turnstile.render('#turnstile_support_verify', {
        //     sitekey: turnstileSiteKey,
        //     theme: 'light',
        // });
    });
});